import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Isvg from 'react-inlinesvg';
import '../../styles/core.scss';
import css from './certificates.scss';
import CertificateCount from '../certificate-count/certificate-count';
import GoldBarIcon from '../../assets/images/goldBar.svg';
import GoldCertificateIcon from '../../assets/images/gold-certificate.png';
import BronzeCertificateIcon from '../../assets/images/bronze-certificate.png';
import SilverCertificateIcon from '../../assets/images/silver-certificate.png';


/**
 * Certificate component
 * Displays number of Gold, Silver and Bronze certificates earned by the student
 * Also displays Gold bars earned by the student for a selected time period
 */
class Certificates extends Component {
    static propTypes = {
        pastCertificateSummary: PropTypes.shape({
            gold: PropTypes.string,
            silver: PropTypes.string,
            bronze: PropTypes.string,
            goldBars: PropTypes.number
        }),
        localeData: PropTypes.object
    };

    constructor(props) {
        super(props);
        const { pastCertificateSummary, localeData } = props;
        const { goldPast, silverPast, bronzePast, goldBarsPast } = pastCertificateSummary;
        this.state = {
            certificates: [
                {
                    title: localeData['Label - Bronze'],
                    count: bronzePast,
                    icon: BronzeCertificateIcon
                },
                {
                    title: localeData['Label - Silver'],
                    count: silverPast,
                    icon: SilverCertificateIcon
                },
                {
                    title: localeData['Label - Gold'],
                    count: goldPast,
                    icon: GoldCertificateIcon
                }],
            certGoldBars: `${goldBarsPast} ${localeData['Cert - Gold Bars']}`,
            certLabel: localeData['Label - PastCertificates']
        };
    }

    render() {
        const { certificates, certGoldBars, certLabel } = this.state;

        return (
            <div className={css.component} >
                <div className={css.heading}>{certLabel}</div>

                <div className={css.certificates}>
                    {certificates.map(certificate => (
                        <div key={certificate.title}>
                            <CertificateCount
                                icon={certificate.icon}
                                title={certificate.title}
                                count={certificate.count} />
                        </div>
                    ))}
                </div>
                <div className={css.goldbar}>
                    <Isvg src={GoldBarIcon} cacheGetRequests />
                    <div className={css.goldbarCount}>{certGoldBars}</div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        localeData: state.localeData
    };
}
export default connect(mapStateToProps)(styleable(css)(Certificates));



// WEBPACK FOOTER //
// ./components/certificates/certificates.js